import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { EmailSettingsInteractions } from './types';

export function emailSettingsChangedEvent({
  action,
}: {
  action: EmailSettingsInteractions;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.EMAIL_SETTINGS_CHANGED,
  };

  pushToDataLayer({
    ...eventAttributes,
    action,
  });
}
